import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Alert,
  Tooltip,
  InputAdornment,
  Grid,
  Button
} from "@mui/material";
import DatePickerCustom2 from "components/DatePickerCustom2";
import TextFieldCustom from "components/TextFieldCustom";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import Spinner from "components/spinner/Spinner";
import { USER_ROLES } from "constants";
import dayjs from "dayjs";
import { displayNotification, generateOptionsFromData, sendAPIRequest } from "helpers";
import {
  FUNDING_SOURCE,
  MISSION_STATUS,
  MISSION_STATUS_LIST,
} from "modules/pvs_activities/constants";
import SiteLoader from "pages/components/SiteLoader";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setAuthState } from 'redux/authSlice';
import InfoIcon from "@mui/icons-material/Info";
import { FaFileUpload, FaTimes } from "react-icons/fa";

const MissionRequestForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef();

  const authData = useSelector((s) => s.auth.data);
  const initialForm = {
    mission_delegate_id: USER_ROLES.delegate.includes(
      parseInt(authData?.role_id)
    )
      ? authData?.id
      : "",
    first_name: USER_ROLES.delegate.includes(parseInt(authData?.role_id))
      ? authData?.person?.first_name
      : "",
    last_name: USER_ROLES.delegate.includes(parseInt(authData?.role_id))
      ? authData?.person?.last_name
      : "",
    email: USER_ROLES.delegate.includes(parseInt(authData?.role_id))
      ? authData?.email
      : "",
    country_id: USER_ROLES.delegate.includes(parseInt(authData?.role_id))
      ? authData?.person?.country_id
      : "",
    comments: "",
    mission_preferred: "",
    mission_type_id: "",
    mission_status_id: MISSION_STATUS_LIST.ongoing,
    mission_sector_id: "",
    funding_source_id: "",
    funding_source_comment: "",
    status: MISSION_STATUS.REQUEST,
  };
  const [form, setForm] = useState({ ...initialForm });
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [missionStatus, setMissionStatus] = useState([]);
  const [fundingSource, setFundingSource] = useState([]);
  const [fundingOption, setFundingOption] = useState({ id: null, ref_id: "" });
  const [SelfFunding, setSelfFunding] = useState([]);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [activityTypeFilters, setActivityTypeFilters] = useState({
    activityType: [],
    sector: [],
    phase: [],
    mission_type: [],
  });

  const [sector, setSector] = useState([]);
  // const [phase, setPhase] = useState([]);
  const [missionTypes, setMissionTypes] = useState([]);

  const [emailError, setEmailError] = useState(false);
  const { id } = useParams();
  const sectorOption = [{
    id: 412,
    list_element_name: 'Terrestrial'
  }]

  useEffect(() => {
    loadCountries();
    loadMissionStatus();
    loadSelfFunding();
    loadSector();
    // loadPhases();
    // loadActivityType();
    if (id) {
      loadMission()
    }
  }, [id]);

  useEffect(() => {
    loadFundingSource();
  }, [id]);

  useEffect(() => {
    loadMissionTypes();
  }, [activityTypeFilters]);

  const goBack = () => {
    navigate(-1);
  };

  // const ActivityTypesOptions = useMemo(() => {
  //   return generateOptionsFromData(activityTypes, {
  //     value: "id",
  //     label: "list_element_name",
  //   });
  // }, [activityTypes]);

  // const activityTypeOptions = useMemo(() => {
  //   return generateOptionsFromData(activityTypeFilters.activityType, {
  //     value: "id",
  //     label: "activity_type_name",
  //   });
  // }, [activityTypeFilters.activityType]);

  const SectorOptions = useMemo(() => {
    return generateOptionsFromData(sector, {
      value: "id",
      label: "list_element_name",
    });
  }, [sector]);

  // const PhaseOptions = useMemo(() => {
  //   return generateOptionsFromData(phase, {
  //     value: "id",
  //     label: "list_element_name",
  //   });
  // }, [phase]);

  const missionTypesOptions = useMemo(() => {
    return generateOptionsFromData(missionTypes, {
      value: "id",
      label: "name",
    });
  }, [missionTypes]);

  const navigationFunction = (key, value) => {
    let params = { ...activityTypeFilters };
    params[key] = value;
    setActivityTypeFilters({
      ...params,
    });
    setForm({
      ...form,
      mission_type_id: null,
    });
  };

  const handleMissionTypeChange = (event, value) => {
    setForm({
      ...form,
      mission_type_id: value ? value.value : null,
    });
  };

  const loadCountries = async () => {
    try {
      const req = await sendAPIRequest(`/api/country`);
      const res = await req.json();
      if (res.success) {
        setCountries(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const loadMissionStatus = async () => {
    try {
      const req = await sendAPIRequest(
        `/api/list/master/18?order_by=display_order,asc`
      );
      const res = await req.json();
      if (res.success) {
        setMissionStatus([...res.data]);
      } else {
        displayNotification("error", `${t("222", "Error loading data")} [B]`);
      }
    } catch (e) {
      console.log(e);
      displayNotification("error", `${t("222", "Error loading data")} [F]`);
    }
  };

  const loadFundingSource = async () => {
    try {
      const req = await sendAPIRequest(`/api/list/master-key/FS`);
      const res = await req.json();
      if (res.success) {
        setFundingSource([...res.data]);
        if (window.location.pathname.includes("view")) {
          const matched = res.data.find(item => item.id === form.funding_source_id);
          if (matched) {
            setFundingOption({
              id: matched.id,
              ref_id: matched.ref_id,
            });
            return;
          } else {
            const filteredRecord = res.data.find((item) => item.ref_id === FUNDING_SOURCE.self_funding);
            if (filteredRecord) {
              setFundingOption({
                id: filteredRecord.id,
                ref_id: filteredRecord.ref_id,
              });
            }
          }
        } else {
          const refIds = Object.values(FUNDING_SOURCE); // ['FS_SF', 'FS_RWLF']
          const filteredRecord = res.data.find((item) =>
            refIds.includes(item.ref_id)
          );
          if (filteredRecord) {
            setFundingOption({
              id: filteredRecord.id,
              ref_id: filteredRecord.ref_id,
            });
          }
        }

      }
    } catch (e) {
      console.log(e);
    }
  };

  const loadSelfFunding = async () => {
    try {
      const req = await sendAPIRequest(
        `/api/list/master/56?order_by=display_order,asc`
      );
      const res = await req.json();
      if (res.success) {
        setSelfFunding([...res.data]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  //New Functions

  // const loadActivityType = async () => {
  //   try {
  //     const data = await sendAPIRequest("/api/list/master/64");
  //     const response = await data.json();
  //     if (response.success && response.status === 200) {
  //       setActivityTypes(response.data)
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // will use when work with other mission type i am defining one type static for now
  const loadSector = async () => {
    try {
      // const data = await sendAPIRequest("/api/list/master/51");
      // const response = await data.json();
      // if (response.success && response.status === 200) {
      //   setSector(response.data)
      // }
      setSector(sectorOption)
    } catch (e) {
      console.log(e);
    }
  };

  // const loadPhases = async () => {
  //   try {
  //     const data = await sendAPIRequest("/api/list/master/54");
  //     const response = await data.json();
  //     if (response.success && response.status === 200) {
  //       setPhase(response.data)
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const loadMissionTypes = async () => {
    try {
      let fltr = { ...activityTypeFilters };
      let params = new URLSearchParams();
      fltr.sector.forEach((element) => {
        params.append("competency_type", element);
      });
      // fltr.phase.forEach((element) => {
      //   params.append("phase", element);
      // });
      fltr.activityType.forEach((element) => {
        params.append("activity_type", element);
      });
      params.append("status", 1);
      const req = await sendAPIRequest(`/api/activity-types/?phase=429&${params}`);
      const res = await req.json();
      if (res.success) {
        setMissionTypes(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };


  const handleRadioButton = (event) => {
    const selectedOption = fundingSource.find(
      (option) => option.id.toString() === event.target.value
    );
    if (selectedOption) {
      setFundingOption({
        id: selectedOption.id,
        ref_id: selectedOption.ref_id,
      });
    }
  };

  const handlePopupValueChange = (val) => {
    setForm({ ...form, funding_source_id: val });
  };

  const loadMission = async () => {
    setIsLoading(true)
    try {
      const req = await sendAPIRequest(`/api/pvsa/mission-request/${id}`, 'GET');
      const res = await req.json();
      if (res.success) {
        setForm({ ...form, ...res.data });
        setIsLoading(false)
      } else {
        displayNotification('error', `${t("889", "Error logging in")} [F]`);
      }
    } catch (e) {
      console.log(e);
      displayNotification('error', `${t("889", "Error logging in")} [F]`);
    }
  }
  const handleSave = async () => {
    if (isBtnLoading) return;
    try {
      setIsBtnLoading(true);
      if (!form.country_id || !form.mission_type_id) {
        displayNotification("info", "Please fill all required fileds");
        setIsBtnLoading(false);
        return;
      }
      if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        displayNotification("error", "Please enter a valid email address");
        setEmailError(true);
        setIsBtnLoading(false);
        return;
      }
      if (form.mission_preferred) {
        const currentYear = dayjs().year();
        const currentMonth = dayjs().month();

        if (
          !form.mission_preferred ||
          dayjs(form.mission_preferred).year() < currentYear ||
          (dayjs(form.mission_preferred).year() === currentYear && dayjs(form.mission_preferred).month() < currentMonth)
        ) {
          displayNotification("error", `Invalid date! Please select a valid date from ${dayjs().format("MM YYYY")} onwards.`);
          setIsBtnLoading(false);
          return;
        }
      }
      const formData = new FormData();
      formData.append("first_name", form.first_name);
      formData.append("last_name", form.last_name);
      formData.append("email", form.email);
      formData.append("country_id", form.country_id);
      formData.append("comments", form.comments);
      formData.append("mission_type_id", form.mission_type_id);
      formData.append("mission_status_id", form.mission_status_id);
      if (fundingOption.ref_id == FUNDING_SOURCE.request_woah) {
        formData.append("funding_source_id", fundingOption.id);
      } else {
        formData.append("funding_source_id", form.funding_source_id);
      }
      formData.append("funding_source_comment", form.funding_source_comment);
      formData.append("mission_preferred", form.mission_preferred);
      formData.append("status", form.status);
      if (selectedFile) {
        formData.append("file_name", selectedFile);
      }
      const data = await sendAPIRequest(
        "/api/pvsa/mission-request",
        "POST",
        formData
      );
      const response = await data.json();
      if (response.success) {
        displayNotification("success", response.message);
        setIsBtnLoading(false);
        navigate(-1);
        dispatch(setAuthState({ ...authData, has_mission: true, has_active_mission: true }));
      } else {
        setIsBtnLoading(false);
        displayNotification("error", response.message);
      }
    } catch (e) {
      setIsBtnLoading(false);
    }
  };

  let cancelButton = () => {
    setForm({ ...initialForm })
    setSelectedFile("")
    setActivityTypeFilters({
      activityType: [],
      sector: [],
      phase: [],
      mission_type: [],
    })
  }

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleReset = () => {
    // console.log("e");
    // setForm({ ...initialForm });
    setSelectedFile("");
  };

  return (
    <>
      {USER_ROLES.delegate.includes(parseInt(authData?.role_id))}

      <div className="container my-2">
        {!id ?
          <div className="py-6 bg-dark text-center text-white fw-bold fs-4">
            {t("-1", "WELCOME TO NEW MISSION FORM")}
          </div>
          : <></>}
        {isLoading ? (
          <div className="card-body p-4">
            <SiteLoader position="relative" background="transparent" />
          </div>
        ) : (
          <>
            <div className="header bg-beige1 card-woah border border-secondary px-4 py-2 shadow-sm w-100 my-2">
              <div className="d-flex">
                {
                  !id ? (
                    <div className="card-title1 lh-1">
                      {t("-1", "Request a New Mission")}
                    </div>
                  ) : (
                    <div className="card-title1 lh-1">
                      {t("-1", "View Mission Request")}
                    </div>
                  )
                }
                <div className="header-right-items d-flex align-items-center ms-auto">
                  <div className="ms-auto">
                    <button
                      className="btn btn--primary fs-7 lh-1"
                      onClick={goBack}
                    >
                      {" "}
                      <i className="fas fa-angle-left text-white" />
                      {t("32", "Back")}
                    </button>
                  </div>
                </div>
              </div>

              <div>Fields with * are mandatory</div>
            </div>

            <div className="border border-beige border-bottom-2 border-top-0 border-right-0 border-left-0">
              <div className="col-12 mb-1">
                <div className="card-title1">{t("-1", "Mission Details")}</div>
              </div>
              <div className="row pt-3 mb-4">
                <div className={`mb-4 ${id ? "col-md-6" : "col-md-12"}`}>
                  <Autocomplete
                    componentsProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-listbox": {
                            border: "1px solid black",
                          },
                        },
                      },
                      popper: {
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, 10],
                            },
                          },
                        ],
                      },
                    }}
                    options={countries}
                    getOptionLabel={(option) => option.country_name}
                    value={
                      countries.find(
                        (option) =>
                          String(option.id) === String(form.country_id)
                      ) || null
                    }
                    onChange={(event, value) =>
                      setForm({
                        ...form,
                        country_id: value ? value.id : null,
                      })
                    }
                    disabled={USER_ROLES.delegate.includes(
                      parseInt(authData?.role_id)
                    ) || id}
                    renderOption={(props, option, { selected }) => (
                      <li
                        style={{
                          borderBottom:
                            option !== countries[countries.length - 1]
                              ? "1px solid black"
                              : "none",
                        }}
                        {...props}
                      >
                        {option.country_name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextFieldCustom
                        {...params}
                        label={t("22", "Country")}
                        fullWidth
                        size="small"
                        required={true}
                        disabled={USER_ROLES.delegate.includes(
                          parseInt(authData?.role_id)
                        ) || id}
                      />
                    )}
                    limitTags={2}
                  />
                </div>
                <>
                  {!(id || window.location.pathname.includes("view")) && (
                    <div className="col-md-4 col-sm-6 col-12">
                      <Tooltip
                        title={t("667", "You can select multiple options")}
                        placement="top"
                        arrow
                      >
                        <>
                          <AutoCompleteDropdown
                            error={false}
                            required={true}
                            label={t("-1", "Sector")}
                            multiple={true}
                            hasselectall={true}
                            options={SectorOptions}
                            onChange={(event, value) => {
                              if (value.some((v) => v.value == "Select all")) {
                                if (activityTypeFilters.sector.length == SectorOptions.length) {
                                  // Deselect all options
                                  navigationFunction("sector", []);
                                } else {
                                  // Select all options
                                  navigationFunction("sector", SectorOptions.map((r) => r.value));
                                }
                              } else {
                                navigationFunction("sector", value.map((r) => r.value));
                              }
                            }}
                            value={activityTypeFilters.sector}
                          />
                        </>
                      </Tooltip>
                    </div>)
                  }
                  <div className="col-md-4 col-sm-6 col-12">
                    <Tooltip
                      title={t("667", "You can select multiple options")}
                      placement="top"
                      arrow
                    >
                      <>
                        <AutoCompleteDropdown
                          error={false}
                          required={true}
                          label={t("-1", "Mission Types")}
                          multiple={false}
                          hasselectall={true}
                          options={missionTypesOptions}
                          onChange={handleMissionTypeChange}
                          disabled={id ? true : activityTypeFilters.sector.length < 1}
                          value={missionTypesOptions.find(option => option.value === form.mission_type_id) || null}
                        />
                      </>
                    </Tooltip>
                  </div>

                  {/* 
                    <div className={`${id ? "mb-4 col-md-6 col-sm-6 col-6" : "col-md-4 col-sm-6 col-12"}`}>
                      <Tooltip
                        title={t("667", "You can select multiple options")}
                        placement="top"
                        arrow
                      >
                        <>
                          <AutoCompleteDropdown
                            error={false}
                            required={false}
                            label={t("-1", "Activity Type")}
                            multiple={true}
                            hasselectall={true}
                            options={ActivityTypesOptions}
                            onChange={(event, value) => {
                              if (value.some((v) => v.value == "Select all")) {
                                if (activityTypeFilters.activityType.length == activityTypeOptions.length) {
                                  // Deselect all options
                                  navigationFunction("activityType", []);
                                } else {
                                  // Select all options
                                  navigationFunction("activityType", activityTypeOptions.map((r) => r.value));
                                }
                              } else {
                                navigationFunction("activityType", value.map((r) => r.value));
                              }
                            }}
                            value={activityTypeFilters.activityType}
                          />
                        </>
                      </Tooltip>
                    </div> */}

                  {/* <div className="col-md-4 col-sm-6 col-12">
                      <Tooltip
                        title={t("667", "You can select multiple options")}
                        placement="top"
                        arrow
                      >
                        <>
                          <AutoCompleteDropdown
                            error={false}
                            required={false}
                            label={t("-1", "Phase")}
                            multiple={true}
                            hasselectall={true}
                            options={PhaseOptions}
                            onChange={(event, value) => {
                              if (value.some((v) => v.value == "Select all")) {
                                if (activityTypeFilters.phase.length == PhaseOptions.length) {
                                  // Deselect all options
                                  navigationFunction("phase", []);
                                } else {
                                  // Select all options
                                  navigationFunction("phase", PhaseOptions.map((r) => r.value));
                                }
                              } else {
                                navigationFunction("phase", value.map((r) => r.value));
                              }
                            }}
                            value={activityTypeFilters.phase}
                          />
                        </>
                      </Tooltip>
                    </div> */}
                </>
                {/* )} */}


                <div className="col-md-12 py-2 mb-3 ">
                  <Alert
                    severity="info"
                    sx={{ justifyContent: "start", alignItems: "center" }}
                    className="fs-5 "
                  >
                    Please note that while we will make every effort to
                    accommodate your preferred month, there is no guarantee it
                    will be allocated. This is due to a variety of logistical
                    considerations.
                  </Alert>
                </div>
                <div className="col-md-12">
                  <DatePickerCustom2
                    label={t("-1", "Preferred Mission Month")}
                    value={
                      dayjs(form.mission_preferred)
                    }
                    onChange={(value) =>
                      setForm({ ...form, mission_preferred: value })
                    }
                    slotProps={{ textField: { size: "small", inputProps: { readOnly: true } } }}
                    sx={{ width: "100%" }}
                    error={false}
                    disabled={id ? true : false}
                    minDate={dayjs()}
                    format="MM-YYYY"
                  />
                </div>

              </div>
            </div>

            <div className="border border-beige border-bottom-2 border-top-0 border-right-0 border-left-0">
              <div className="col-12">
                <div className="card-title1">{t("-1", "Funding Source")}</div>
              </div>
              <div className="col-md-12 ">
                <Alert severity="info" sx={{ justifyContent: "start", alignItems: "center" }} className="fs-5">
                  Please note that international travel costs, per diem
                  allowances (to cover hotel and other accommodation costs), and
                  remuneration of the PVS Experts that will carry out this
                  activity may be covered by WOAH.
                </Alert>
              </div>
              <div className="row pt-3 pb-2 mb-4 g-0" >
                <div className="col-md-12 py-2 border border-beige rounded-2 justify-content-center d-flex " >
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      className="text-center d-flex justify-content-between"
                      onChange={handleRadioButton}
                      disabled={id ? true : false}
                      value={fundingOption.id}
                    >
                      {fundingSource.map((option) => (
                        <FormControlLabel
                          key={option.id}
                          className="px-5 mb-2"
                          value={option.id.toString()}
                          control={<Radio />}
                          disabled={id ? true : false}
                          label={option.list_element_name}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>

                </div>
                <div className="col-md-12 pt-2">
                  <Alert severity="info" sx={{ justifyContent: "start", alignItems: "center" }} className="fs-5">
                    You may provide details of your funding source including any timeline pressures or upcoming funding deadlines.
                  </Alert>
                </div>
                {FUNDING_SOURCE.self_funding === fundingOption.ref_id && (
                  <>
                    <div className="col-md-12 py-2 mb-4">
                      <Autocomplete
                        componentsProps={{
                          paper: {
                            sx: {
                              "& .MuiAutocomplete-listbox": {
                                border: "1px solid black",
                              },
                            },
                          },
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, 10],
                                },
                              },
                            ],
                          },
                        }}
                        options={SelfFunding}
                        value={SelfFunding.find(
                          (r) => String(r.id) === String(form.funding_source_id)
                        )}
                        disabled={id ? true : false}
                        getOptionLabel={(option) => option.list_element_name}
                        onChange={(event, value) => {
                          handlePopupValueChange(value ? value.id : "");
                        }}
                        renderOption={(props, option) => (
                          <li
                            style={{
                              borderBottom:
                                option !== SelfFunding[SelfFunding.length - 1]
                                  ? "1px solid black"
                                  : "none",
                            }}
                            {...props}
                          >
                            {option.list_element_name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextFieldCustom
                            {...params}
                            label={"Funding Source"}
                            fullWidth
                            size="small"
                            required={false}
                          />
                        )}
                        limitTags={2}
                      />

                    </div>
                    <div className="col-12 mb-4 ">
                      <TextFieldCustom
                        id="outlined-multiline-flexible"
                        label={t("-1", "Funding Source Details")}
                        multiline
                        rows={5}
                        disabled={id ? true : false}
                        value={form.funding_source_comment}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            funding_source_comment: e.target.value,
                          })
                        }
                        fullWidth
                        size="small"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="border border-beige border-bottom-2 border-top-0 border-right-0 border-left-0">
              <div className="col-12 mb-1">
                <div className="card-title1">
                  {t("-1", "Mission Contact Details")}
                </div>
              </div>
              <div className="col-md-12 py-2 mb-1">
                <Alert severity="info" sx={{ justifyContent: "start", alignItems: "center" }} className="fs-5">
                  If you do not yet know who will be the Mission Contact
                  Person, the Delegate will remain the principal contact until
                  you nominate another person.
                </Alert>
              </div>
              <div className="row pt-3 mb-4">
                <div className="col-md-4">
                  <TextFieldCustom
                    id="outlined-basic"
                    label={t("-1", "First Name")}
                    variant="outlined"
                    required={false}
                    disabled={id ? true : false}
                    value={form.first_name}
                    onChange={(e) =>
                      setForm({ ...form, first_name: e.target.value })
                    }
                    // disabled={USER_ROLES.delegate.includes(
                    //   parseInt(authData?.role_id)
                    // )}
                    fullWidth
                    size="small"
                  />
                </div>
                <div className="col-md-4">
                  <TextFieldCustom
                    id="outlined-basic"
                    label={t("-1", "Last Name")}
                    variant="outlined"
                    required={false}
                    value={form.last_name}
                    disabled={id ? true : false}
                    onChange={(e) =>
                      setForm({ ...form, last_name: e.target.value })
                    }
                    // disabled={USER_ROLES.delegate.includes(
                    //   parseInt(authData?.role_id)
                    // )}
                    fullWidth
                    size="small"
                  />
                </div>
                <div className="col-md-4">
                  <TextFieldCustom
                    id="outlined-basic"
                    label={t("-1", "Email")}
                    variant="outlined"
                    required={false}
                    value={form.email}
                    disabled={id ? true : false}
                    onChange={(e) => {
                      setEmailError(false);
                      setForm({ ...form, email: e.target.value });
                    }}
                    fullWidth
                    size="small"
                    error={emailError}
                    helperText={emailError ? "Please enter a valid email address" : ""}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip
                            title={
                              <>
                                Valid Email Examples: <br />
                                {"user@example.com"} <br />
                                {"user.1@company.org"} <br />
                                {"user_2@domain.co.uk"} <br />
                                {"contact@sub.domain.net"}
                              </>
                            }
                          >
                            <InfoIcon fontSize="medium" style={{ cursor: "pointer", color: "#666" }} />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>

              </div>
            </div>
            <div className="border border-beige border-bottom-2 border-top-0 border-right-0 border-left-0">
              <div className="col-12 mb-1">
                <div className="card-title1">
                  {t("-1", "Mission Request Letter")}
                </div>
              </div>
              <div className="col-md-12 py-2 mb-1" >
                <Alert severity="info" sx={{ justifyContent: "start", alignItems: "center" }} className="fs-5">
                  Please upload an official mission request letter
                </Alert>
              </div>
              <>
                <Box sx={{ p: 2 }} className="bg-light-2" style={{ BorderStyle: '1px dotted #B2320E' }}>
                  <Grid container spacing={1}>
                    {selectedFile ? (
                      <>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                          <div className="d-flex">
                            <div
                              className="px-3 py-2 flex-grow-1 d-inline-flex"
                              style={{
                                border: "1px solid  #ccc",
                                borderRight: 0,
                                minWidth: 150,
                                overflow: "hidden",
                                backgroundColor: "#fff",
                              }}
                            >
                              {selectedFile && selectedFile.name}
                            </div>
                            <Button
                              variant={"contained"}
                              color="error"
                              sx={{ alignSelf: "stretch" }}
                              onClick={handleReset}
                              disabled={isUploading}
                              disableElevation={true}
                            >
                              <FaTimes />
                            </Button>
                          </div>
                        </Grid>
                      </>
                    ) : (
                      <Grid
                        item
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "start", gap: 2 }}
                      >
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          accept=".doc,.docx,.pdf,.xls,.xlsx,image/*"
                          onChange={handleFileChange}
                        />
                        <Button
                          variant={"contained"}
                          color="primary"
                          sx={{ my: "auto" }}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          <FaFileUpload />
                          <span className="ms-1">Browse File</span>
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Box>

                {/* asdsad */}
                <hr className="m-0 p-0" style={{ borderColor: "#ccc", borderWidth: 2 }} />
              </>
            </div>

            {/* Attachment */}
            <div>
              <div className="col-12">
                <div className="card-title1">{t("-1", "Comments")}</div>
              </div>
              <div className="col-md-12 py-1">
                <Alert severity="info" sx={{ justifyContent: "start", alignItems: "center" }} className="fs-5">
                  Please advise on any information critical for consideration of
                  request (e.g. funding deadlines, security or sanitary
                  situation, projects linked to request, any other
                  requirements, etc.)
                </Alert>
              </div>

              <div className="col-12 mb-4 py-2">
                <TextFieldCustom
                  id="outlined-multiline-flexible"
                  label={t("279", "Comments")}
                  multiline
                  rows={5}
                  disabled={id ? true : false}
                  value={form.comments}
                  onChange={(e) =>
                    setForm({ ...form, comments: e.target.value })
                  }
                  fullWidth
                  size="small"
                />
              </div>
            </div>

            <div className="col-12 mb-3 text-end">
              <button
                className="btn btn--outline fs-7 lh-1 ms-1"
                type="button"
                onClick={cancelButton}
              >
                <span className="align-middle">{t("-1", "Reset")}</span>
                <i className="fas fa-arrow-rotate-left text-black ms-2 mt-1" />
              </button>
              <button
                className="btn btn--primary fs-7 lh-1 ms-1"
                type="button"
                disabled={isBtnLoading || id}
                onClick={handleSave}
              >
                {isBtnLoading ? (
                  <Spinner message="Saving..." />
                ) : (
                  <>
                    <span className="align-middle">{t("85", "Save")}</span>
                    <i className="fa-sharp fas fa-check text-white ms-2"></i>
                  </>
                )}
              </button>
            </div>
          </>
        )}

      </div>
    </>
  );
};

export default MissionRequestForm;
